const NA = 'Not available';
const NOT_TRACKED = 'Not tracked by platform';

export function safeNumber(value: unknown): number | null {
  if (typeof value !== 'number') return null;
  if (!Number.isFinite(value)) return null;
  return value;
}

export function formatKg(value: unknown): string {
  const n = safeNumber(value);
  if (n === null) return NA;
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 2 })} kg`;
}

export function formatPercent(value: unknown): string {
  const n = safeNumber(value);
  if (n === null) return NA;
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;
}

export function formatSar(value: unknown): string {
  const n = safeNumber(value);
  if (n === null) return NA;
  return n.toLocaleString('en-US', { style: 'currency', currency: 'SAR' });
}

export function formatCount(value: unknown): string {
  const n = safeNumber(value);
  if (n === null) return NA;
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function formatHours(value: unknown): string {
  const n = safeNumber(value);
  if (n === null) return NA;
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 1 })} hrs`;
}

export function displayOrUnavailable(value: unknown): string {
  if (value === null || value === undefined) return NA;
  if (typeof value === 'number' && !Number.isFinite(value)) return NA;
  if (typeof value === 'string' && value.trim() === '') return NA;
  return String(value);
}

export function notTrackedDisposal(): string {
  return NOT_TRACKED;
}

export function unavailableLabels(): { na: string; notTracked: string } {
  return { na: NA, notTracked: NOT_TRACKED };
}
